/* LOCO Message Lab landing pages - tiny template runtime.
   Renders a <template> using {{ path }} holes, <sc-for list as>, <sc-if value>,
   and on* handlers bound to functions returned by a Component's renderVals(). */
(function () {
  'use strict';
  var HOLE = /\{\{\s*([^}]+?)\s*\}\}/g;
  var EXACT = /^\s*\{\{\s*([^}]+?)\s*\}\}\s*$/;

  function lookup(scope, path) {
    path = path.trim();
    if (path === 'true') return true;
    if (path === 'false') return false;
    var parts = path.split('.');
    var v = scope;
    for (var i = 0; i < parts.length; i++) {
      if (v == null) return undefined;
      v = v[parts[i]];
    }
    return v;
  }
  function interp(str, scope) {
    return str.replace(HOLE, function (_, p) {
      var v = lookup(scope, p);
      return v == null ? '' : String(v);
    });
  }

  // Build a fresh DOM tree (a DocumentFragment) from template nodes and scope.
  function build(srcNodes, scope, out) {
    for (var i = 0; i < srcNodes.length; i++) {
      var n = srcNodes[i];
      if (n.nodeType === 3) {
        out.appendChild(document.createTextNode(interp(n.nodeValue, scope)));
        continue;
      }
      if (n.nodeType !== 1) continue;
      var tag = n.nodeName.toLowerCase();
      if (tag === 'sc-for') {
        var m = EXACT.exec(n.getAttribute('list') || '');
        var list = m ? lookup(scope, m[1]) : null;
        var as = n.getAttribute('as') || 'item';
        if (list && list.length) {
          for (var j = 0; j < list.length; j++) {
            var s = Object.create(scope);
            s[as] = list[j];
            build(n.childNodes, s, out);
          }
        }
        continue;
      }
      if (tag === 'sc-if') {
        var mv = EXACT.exec(n.getAttribute('value') || '');
        if (mv && lookup(scope, mv[1])) build(n.childNodes, scope, out);
        continue;
      }
      var ns = n.namespaceURI;
      var el = (!ns || ns === 'http://www.w3.org/1999/xhtml') ? document.createElement(n.localName) : document.createElementNS(ns, n.localName);
      el.__h = {};
      for (var a = 0; a < n.attributes.length; a++) {
        var at = n.attributes[a];
        var name = at.name;
        if (name.indexOf('hint-') === 0) continue;
        var val = at.value;
        var lname = name.toLowerCase();
        if (lname.indexOf('on') === 0 && lname.length > 2) {
          var me = EXACT.exec(val);
          var fn = me ? lookup(scope, me[1]) : null;
          if (typeof fn === 'function') el.__h[lname.slice(2)] = fn;
          continue;
        }
        var ex = EXACT.exec(val);
        if (ex) {
          var raw = lookup(scope, ex[1]);
          if (raw === false || raw == null) {
            if (lname === 'checked' || lname === 'disabled' || lname === 'selected' || lname === 'open') continue;
            if (raw == null) continue;
          }
          if (raw === true && (lname === 'checked' || lname === 'disabled' || lname === 'selected' || lname === 'open')) {
            el.setAttribute(name, '');
            continue;
          }
          el.setAttribute(name, String(raw));
        } else {
          el.setAttribute(name, interp(val, scope));
        }
      }
      var src = tag === 'template' ? n.content.childNodes : n.childNodes;
      build(src, scope, el);
      out.appendChild(el);
    }
    return out;
  }

  function bindEvents(el) {
    if (!el.__bound) el.__bound = {};
    var h = el.__h || {};
    Object.keys(h).forEach(function (ev) {
      if (!el.__bound[ev]) {
        el.__bound[ev] = true;
        el.addEventListener(ev, function (e) {
          var f = el.__h && el.__h[ev];
          if (f) f(e);
        });
      }
    });
  }

  // Patch live DOM `to` so it matches freshly built `from` (same parent).
  function morphChildren(live, fresh) {
    var a = Array.prototype.slice.call(live.childNodes);
    var b = Array.prototype.slice.call(fresh.childNodes);
    for (var i = 0; i < b.length; i++) {
      var nb = b[i], na = a[i];
      if (!na) { live.appendChild(adopt(nb)); continue; }
      if (na.nodeType !== nb.nodeType || na.nodeName !== nb.nodeName) {
        live.replaceChild(adopt(nb), na);
        continue;
      }
      if (nb.nodeType === 3) {
        if (na.nodeValue !== nb.nodeValue) na.nodeValue = nb.nodeValue;
        continue;
      }
      morphEl(na, nb);
    }
    for (var k = a.length - 1; k >= b.length; k--) live.removeChild(a[k]);
  }
  function adopt(n) {
    if (n.nodeType === 1) walk(n, bindEvents);
    return n;
  }
  function walk(n, f) {
    f(n);
    for (var c = n.firstElementChild; c; c = c.nextElementSibling) walk(c, f);
  }
  function morphEl(a, b) {
    // attributes
    for (var i = a.attributes.length - 1; i >= 0; i--) {
      var nm = a.attributes[i].name;
      if (!b.hasAttribute(nm)) a.removeAttribute(nm);
    }
    for (var j = 0; j < b.attributes.length; j++) {
      var at = b.attributes[j];
      if (a.getAttribute(at.name) !== at.value) a.setAttribute(at.name, at.value);
    }
    var tag = a.nodeName.toLowerCase();
    if (tag === 'input' || tag === 'textarea' || tag === 'select') {
      if (b.hasAttribute('value') && a.value !== b.getAttribute('value') && document.activeElement !== a) a.value = b.getAttribute('value');
      if (a.type === 'checkbox' || a.type === 'radio') a.checked = b.hasAttribute('checked');
    }
    a.__h = b.__h;
    bindEvents(a);
    morphChildren(a, b);
  }

  function DCLogic(props) {
    this.props = props || {};
    this.state = {};
  }
  DCLogic.prototype.setState = function (patch) {
    var p = typeof patch === 'function' ? patch(this.state, this.props) : patch;
    for (var k in p) if (Object.prototype.hasOwnProperty.call(p, k)) this.state[k] = p[k];
    if (this.__render) this.__render();
  };
  DCLogic.prototype.renderVals = function () { return {}; };
  window.DCLogic = DCLogic;

  window.mlMount = function (rootId, tplId, Comp, props) {
    var root = document.getElementById(rootId);
    var tpl = document.getElementById(tplId);
    if (!root || !tpl) return;
    var inst = new Comp(props || {});
    var first = true;
    inst.__render = function () {
      var vals = inst.renderVals() || {};
      var frag = build(tpl.content.childNodes, vals, document.createDocumentFragment());
      if (first) {
        first = false;
        root.innerHTML = '';
        walk2(frag);
        root.appendChild(frag);
      } else {
        morphChildren(root, frag);
      }
    };
    function walk2(frag) {
      for (var c = frag.firstElementChild; c; c = c.nextElementSibling) walk(c, bindEvents);
    }
    inst.__render();
    if (typeof inst.componentDidMount === 'function') inst.componentDidMount();
  };
})();
